export const MINUTES_IN_A_DAY = 24 * 60;
